import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import { EditorAccessTier } from 'dashboard/apps/InquiryTemplateEditor/hooks/useIsEditableWithOptions';
import useLearnMoreEventClick from 'dashboard/components/ProductUpsellTooltip/useLearnMoreEventClick';
import { Feature } from 'dashboard/models/inquiry-template-version';
import Button from 'design-system/components/Button';
import { Paragraph } from 'design-system/components/Text';
import { HeadingSize, ParagraphSize } from 'design-system/mixins/text';

const getElementSizes = (size: string) => {
  switch (size) {
    case 'md':
      return {
        header: 'md' as HeadingSize,
        body: 'sm' as ParagraphSize,
      };
    default:
      return {
        header: 'sm' as HeadingSize,
        body: 'xs' as ParagraphSize,
      };
  }
};

const BannerContainer = styled.div`
  padding: ${Spacing[4]};
  background-color: ${({ theme }) => theme.color.primary.brand100};
  border-radius: ${({ theme }) => theme.borderRadius};
`;

const BannerHeading = styled(Paragraph)`
  font-size: ${({ theme }) => theme.text.paragraph.md.fontSize};
  color: ${({ theme }) => theme.color.text.primary};
  margin-bottom: ${Spacing[2]};
`;

const BannerText = styled(Paragraph)`
  margin-bottom: ${Spacing[2]};
`;
const BannerButton = styled(Button).attrs({ width: 'auto', size: 'sm' })``;

const ProductUpsellBanner = ({
  message,
  size = 'sm',
  feature,
  accessTier,
  learnMoreId,
}: {
  message: string;
  learnMoreId: string;
  size?: string;
  feature?: Feature;
  accessTier: EditorAccessTier;
}) => {
  const textSizes = getElementSizes(size);
  const { linkElementId, onLearnMoreClick } = useLearnMoreEventClick({ id: learnMoreId });
  return (
    <BannerContainer>
      <BannerHeading size={textSizes.header}>Upgrade plan</BannerHeading>
      <BannerText size={textSizes.body}>{message}</BannerText>
      <BannerButton
        id={linkElementId}
        onClick={() =>
          onLearnMoreClick({
            feature,
            accessTier: accessTier as Exclude<EditorAccessTier, EditorAccessTier.Any>,
          })
        }
      >
        Learn more
      </BannerButton>
    </BannerContainer>
  );
};

export default ProductUpsellBanner;
